module.exports = {"152530100":"上都镇","152530101":"桑根达来镇","152530102":"哈毕日嘎镇","152530200":"宝绍代苏木乡","152530201":"那日图苏木乡","152530202":"赛音呼都嘎苏木乡","152530203":"扎格斯台苏木","152530500":"五一种畜场总场","152530501":"黑城子示范区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152530.json
// module id = 447
// module chunks = 0